import {
  IconSettingsSliderHorizontal,
  Button,
  GreyGrey30,
  InputSelectControl,
  SequenceMenu,
  Flex
} from '@sequencehq/core-components'
import { UseInvoicesGridData } from 'components/Invoices/InvoicesGrid/useInvoicesGrid'
import { InvoicesViewSettingsHeader } from 'components/Invoices/InvoicesViewSettingsHeader'
import { useMemo } from 'react'

type Props = {
  data: UseInvoicesGridData
}

export const InvoicesGridToolbarV3 = ({ data }: Props) => {
  const { enabledCurrencies, currency, updateCurrency } = data

  const currencyOptions = useMemo(
    () =>
      enabledCurrencies.map(enabledCurrency => ({
        label: enabledCurrency,
        value: enabledCurrency
      })),
    [enabledCurrencies]
  )

  return (
    <Flex
      borderBottom={`${GreyGrey30} 1px solid`}
      px="16px"
      py="8px"
      width="100%"
      gap="8px"
      justifyContent="space-between"
      data-testid="invoicesGrid.toolbar"
    >
      <InputSelectControl
        data-testid="invoicesGrid.currencyMenu"
        value={currency ?? ''}
        onChange={updateCurrency}
        options={currencyOptions}
        placeholder="Select currency"
        triggerStyle={{ width: '164px' }}
      />

      <SequenceMenu
        data-testid="invoicesGrid.viewSettingsMenu"
        alignment="bottom-right"
        menuButton={
          <Button
            variant="secondary"
            leadingIcon={<IconSettingsSliderHorizontal color="inherit" />}
          >
            View settings
          </Button>
        }
        items={<InvoicesViewSettingsHeader />}
      />
    </Flex>
  )
}
